import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

// bootstrap
import Form from "react-bootstrap/Form";

// hooks
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { useHistory, useLocation, Link, Redirect } from "react-router-dom";

// custom components
import { Row, Col } from "react-bootstrap";
import SubmitButton from "../StyledComponents/SubmitButton";
import SmLinkButton from "../StyledComponents/smLinkButton";
import LabelledInput from "../LabelledInput";
import Sallie from '../Sallie'

// api
import { signIn } from "../../api/auth";
import { SignInSchema } from "./validation";


const SignIn = ({ setUser, user }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [credentialError, setCredentialError] = useState(false);
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };

  // create a hook for the form, passing in an object of configs

  const { register, handleSubmit, errors, formState, setError } = useForm({
    resolver: yupResolver(SignInSchema),
  });
  const { touched } = formState;
  const handleClick = () => {
    history.push('/BasicInfo')
  };
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);

      data.email = data.email.toLowerCase();
      const res = await signIn(data);
      setUser(res.data);
      
      // We need a way to set patient state in addition to user state around login time
      if (res.data.userType === "caregiver" || res.data.userType === 'provider') history.replace("/patientControl");
      else history.replace(from);
    } catch (err) {
      if (err.message.includes("409")) {
        alert(t("signIn.errors.alreadyLoggedIn"));
        setIsLoading(false);
      } else {
        setError("email", {
          type: "badCredentials",
          message: t("signIn.errors.badCredentials"),
        });
        setError("password",
          {
            type: "badCredentials",
            message: "",
          });
        setCredentialError(true);
        setIsLoading(false);
      }
    }
  };

  if (user) {
    return (
      <Redirect
        to={{
          pathname: "/",
        }}
      />
    );
  }

  return (
    <>
      <Row>
        <Col md={6} className="order-last order-md-first">
          <Sallie text={t("signIn.signin.sallie")} />
        <p style={{ marginTop: "10px" }}>
          {t("signIn.signin.signupPrompt")}
        </p>
        <p>
          {t("signIn.signin.journeyStart")}
        </p>
        <Row>
          <Col className="justify-content-center d-flex justify-content-md-start">
            <SubmitButton type="button" onClick={handleClick}>{t("signIn.signin.newUserRegistration")}</SubmitButton>
          </Col>
        </Row>
      </Col>
      <Col md={6} className="order-first order-md-last">
        <Form
          autoComplete="on"
          method="POST"
          className="mt-2"
          style={{ margin: "0 auto" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <LabelledInput
            labelAs="h6"
            label={t("signIn.signin.email")}
            name="email"
            type="email"
            autoComplete="email"
            inputRef={register}
            errors={errors}
            touched={touched}
          />

          <LabelledInput
            labelAs="h6"
            label={t("signIn.signin.password")}
            name="password"
            type="password"
            autoComplete="current-password"
            inputRef={register}
            errors={errors}
            touched={touched}
          />

          <SubmitButton disabled={isLoading} className="w-100" type="submit">
            {t("signIn.signin.login")}
          </SubmitButton>
          <Form.Row>
            {credentialError ? (
              <div>
                <div style={{ marginBottom: "15px" }}>
                  {t("signIn.signin.wrongCredentials")}
                </div>
                <div>
                  {t("signIn.signin.forgotPassword")}
                  <SmLinkButton>
                    <Link to="/resetPassword1">{t("signIn.signin.here")}</Link>
                  </SmLinkButton>
                </div>
                <div>
                  {t("signIn.signin.newUser")}
                  <SmLinkButton>
                    <Link to="/BasicInfo">{t("signIn.signin.here")}</Link>
                  </SmLinkButton>
                </div>
              </div>
            ) : (
              <>
                <div style={{ marginBottom: "15px", marginTop: "10px" }}>
                  <Link to="/resetPassword1">{t("signIn.signin.resetPassword")}</Link>
                </div>
              </>
            )}
          </Form.Row>
        </Form>
      </Col>
    </Row>
    </>
  );
};

export default SignIn;